module.exports = __webpack_public_path__ + "media/images/illustrations/skills-development-01-f1d74652366dbfc7bd7aec21545381bb.svg";